module.exports = __webpack_public_path__ + "static/media/logo-black.09234a9d.svg";